// FIX-BUG-CARD-PUSH: the REAL state of browser notices on this device. Pure helpers (no DOM) so the rules are unit-tested.
// "On" means all four: the browser allowed notices, the browser holds a subscription, that subscription was made with
// the server's CURRENT key, and the server has it saved for this user. Anything less = not on (the bar asks again).

export interface PushDeviceState {
  supported: boolean;
  permission: NotificationPermission | 'unsupported';
  /** the browser holds a push subscription */
  browserSubscribed: boolean;
  /** that subscription was made with the server's current VAPID public key (null = unknown) */
  keyMatches: boolean | null;
  /** the server has this subscription saved for the signed-in user (null = could not ask) */
  registeredOnServer: boolean | null;
  /** the server has a valid VAPID pair */
  serverConfigured: boolean;
}

export function isDeviceReallyOn(s: PushDeviceState): boolean {
  return s.supported && s.permission === 'granted' && s.browserSubscribed && s.keyMatches !== false && s.registeredOnServer === true;
}

export type PushDeviceLabel = 'unsupported' | 'denied' | 'server_missing' | 'on' | 'not_registered' | 'off';

/** The one line the profile / settings page shows about THIS browser. */
export function deviceLabel(s: PushDeviceState): PushDeviceLabel {
  if (!s.supported) return 'unsupported';
  if (s.permission === 'denied') return 'denied';
  if (!s.serverConfigured) return 'server_missing';
  if (isDeviceReallyOn(s)) return 'on';
  // allowed in the browser, but the server does not know this browser (or the key changed): must re-register
  if (s.permission === 'granted' && s.browserSubscribed) return 'not_registered';
  return 'off';
}

function b64urlToBytes(b64: string): Uint8Array {
  const padding = '='.repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

/** Was the subscription made with this server key? `subKey` = subscription.options.applicationServerKey (may be null). */
export function subscriptionKeyMatches(subKey: ArrayBuffer | null | undefined, serverKeyB64: string | null | undefined): boolean | null {
  if (!subKey || !serverKeyB64) return null;
  let server: Uint8Array;
  try { server = b64urlToBytes(serverKeyB64); } catch { return null; }
  const a = new Uint8Array(subKey);
  if (a.length !== server.length) return false;
  for (let i = 0; i < a.length; i++) if (a[i] !== server[i]) return false;
  return true;
}
